import { NoteDTO } from '../../services/apiClient';
import { TableAction } from '../common/Table';
import { CheckCircle, Lock, Trash2, UserCog } from 'lucide-react';

interface NoteActionHandlers {
  onDelete: (note: NoteDTO) => Promise<void>;
  onResolve?: (note: NoteDTO) => Promise<void>;
  onViewMember?: (note: NoteDTO) => void;
  onImpersonateMemberLogin?: (note: NoteDTO) => void;
}

const createNoteActions =
  (handlers: NoteActionHandlers) =>
    (row: NoteDTO): TableAction[] => {
      const actions: TableAction[] = [];

      // Only show Resolve action if note is not resolved
      if (handlers.onResolve && !row.isResolved) {
        actions.push({
          label: 'Resolve',
          onClick: () => handlers.onResolve!(row),
          icon: <CheckCircle className="w-4 h-4" />,
          confirmMessage: 'Are you sure you want to mark this note as resolved?',
          className: 'text-green-600 hover:text-green-700',
        });
      }

      if (handlers.onViewMember) {
        actions.push({
          label: 'Member',
          onClick: () => handlers.onViewMember!(row),
          icon: <UserCog className="w-4 h-4" />,
        });
      }

      if (handlers.onImpersonateMemberLogin) {
        actions.push({
          label: 'Login as Member',
          onClick: () => handlers.onImpersonateMemberLogin!(row),
          icon: <Lock className="w-4 h-4" />,
          confirmMessage: 'Are you sure you want to login as this member?',
        });
      }

      actions.push({
        label: 'Delete Note',
        onClick: () => handlers.onDelete(row),
        icon: <Trash2 className="w-4 h-4" />,
        confirmMessage: 'Are you sure you want to delete this member?',
        className: 'text-red-600 hover:text-red-700',
      });

      return actions;
    };

export default createNoteActions;
